import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { ListaCarpeta } from 'app/models/carpeta.model';
import { EstadoPagare } from 'app/models/pagare.model';
import { CarpetaService } from 'app/services/carpeta.service';
import { take } from 'rxjs';
import moment from 'moment';
import { PdfService } from 'app/services/pdf.service';

@Component({
    selector: 'judicial',
    templateUrl: './judicial.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class JudicialComponent {
    constructor(private route: Router, private _carpeta: CarpetaService, private _pdf: PdfService) {}

    columns: TableColumn[] = [
        {
            columnDef: 'RUTDV',
            header: 'RUT',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'RAZON_SOCIAL',
            header: 'NOMBRE CLIENTE',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'FOLIO',
            header: 'FOLIO',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'number',
            columnFormat: '0.0',
            columnSort: true,
        },
        {
            columnDef: 'ID_ESTADO',
            // columnDef: 'NOMBRE_ESTADO',
            header: 'ESTADO',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'flex items-center gap-2',
            columnType: 'custom',
            columnFormat: '',
            columnSort: true,
            columFunction: this.printEstado,
        },
        {
            columnDef: 'CUENTA_FINANCIERA',
            header: 'CTA FINACIERA',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'MONTO_RECAUDADO',
            header: 'MONTO RECAUDADO',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'currency',
            columnFormat: 'CLP',
            columnSort: true,
        },
        {
            columnDef: 'FECHA_CREACION',
            header: 'FECHA CREACIÓN',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/yyyy',
            columnSort: true,
        },
        {
            columnDef: 'ADJUNTO_TOTAL',
            header: 'ARCHIVOS',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'flex items-center gap-2',
            columnType: 'custom',
            columnFormat: '',
            columnSort: false,
            columFunction: this.printArchivos,
        },
    ];

    dataSource: ListaCarpeta[] = [];
    selection = new SelectionModel<ListaCarpeta>(true, []);

    estadosPagare: EstadoPagare[] = [];
    estadoSelected: number = 0;
    estadoCurrentSelection: number = null;
    search: string = '';
    currentSearch: string = '';
    cargandoDatos: boolean = false;
    public customPatterns = { '0': { pattern: new RegExp('^[a-zA-ZñÑáéíóúÁÉÍÓÚ .-@_]{1,30}$') } };
    start: moment.Moment = moment().add(-7, 'd');
    end: moment.Moment = moment().add(1, 'd');

    loadingPrint: boolean = false;

    totalMonto() {
        return this.selection.selected.reduce((prev, item) => prev + item.MONTO_RECAUDADO, 0);
    }
    // formDates: FormGroup = new FormGroup({
    //     end: new FormControl(new Date(Date.now() + 5 * 86400000)),
    //     start: new FormControl(new Date()),
    // });

    // date = new FormControl(new Date());
    ngOnInit() {
        this._carpeta
            .listarEstadosPagare()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.estadosPagare = data;
                    this.listarCarpetas();
                },
                error: (err: any) => {
                    //console.log(err);
                },
                complete: () => {
                    let optDefault: EstadoPagare = {
                        ID_ESTADO: 0,
                        NOMBRE_ESTADO: '',
                    };
                    this.estadosPagare.unshift(optDefault);
                    this.estadoSelected = this.estadosPagare[0].ID_ESTADO;
                },
            });

        /* Asignacion del dataSource, el map es solo para agregar atributos de ejemplo de otros tipos de datos */
        // this.dataSource = ELEMENT_DATA.map((m) => ({ ...m }));
        // this.
    }

    buscarCarpetas() {
        this.currentSearch = this.search;
        this.listarCarpetas();
    }

    dateRangeChange($event: any, dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        // console.log('event', $event);
        // console.log('view start', dateRangeStart.value);
        // console.log('view end', dateRangeEnd.value);
        // console.log('start', this.start);
        // console.log('end', this.end);
        this.listarCarpetas();
    }

    listarCarpetas() {
        // let { start, end } = this.formDates.value;
        if (this.start && this.end) {
            let start = this.start.format('yyyy-MM-DD');
            let end = this.end.format('yyyy-MM-DD');
            this._carpeta
                .listarCarpetas(this.currentSearch, this.estadoSelected, start, end)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.dataSource = data;
                        this.selection = new SelectionModel<ListaCarpeta>(true, []);
                    },
                    error: (err: any) => {
                        console.log(err);
                        this.dataSource = [];
                        this.selection = new SelectionModel<ListaCarpeta>(true, []);
                    },
                    complete: () => {},
                });
        }
    }
    /**
        Función que captura el evento de ver detalle desde tabla custom
    */
    onTableAction(row: any) {
        // console.log('ver detalles de', row);
        this.route.navigateByUrl('home/judicial/detalle/' + row.ID_CARPETA);
    }
    /**
        Función para imprimir campo custom, debe responder siempre un string
    */
    printEstado(row: any, attribute: string): string {
        let dict = {
            1: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            PRE-EMITIDO
                        </p>
                    </div>
                </div>`,
            2: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-01">
                        <p class="paragraph-tag_upper text-primary">
                            CANCELADO
                        </p>
                    </div>
                </div>`,
            3: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            EMITIDO
                        </p>
                    </div>
                </div>`,
            4: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            ENVIADO A NOTARÍA
                        </p>
                    </div>
                </div>`,
            5: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            NOTARIADO
                        </p>
                    </div>
                </div>`,
            6: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-02">
                        <p class="paragraph-tag_upper text-primary-orange-01">
                            ENVIADO A JUDICIAL
                        </p>
                    </div>
                </div>`,
            7: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            JUDICIALIZADO
                        </p>
                    </div>
                </div>`,
            8: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            CON ACUERDO
                        </p>
                    </div>
                </div>`,
            9: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-pink-01">
                        <p class="paragraph-tag_upper text-primary">
                            ANULADO
                        </p>
                    </div>
                </div>`,
            10: `
                <div class="flex justify-start">
                    <div class="rounded-full flex justify-center w-32 h-6 items-center bg-primary-green-04">
                        <p class="paragraph-tag_upper text-primary-green-01">
                            DEVUELTO A CLIENTE
                        </p>
                    </div>
                </div>`,
        };
        return dict[row[attribute]] || '';
    }


    /**
        Función para eliminar del dataSource los elementos seleccionados desde tabla custom.
    */
    // ejemploBorrarSeleccionados() {
    //     // console.log(this.selection.selected);
    //     this.dataSource = this.dataSource.filter(f => !this.selection.selected.some(s => s.position == f.position));
    //     this.selection = new SelectionModel<any>(true, []);
    // }

    printArchivos(row: any, attribute: string): string {
        let salida = '<div class="w-full flex justify-start gap-1 items-center">';
        if (row.ADJUNTO_PAGARE > 0) {
            salida += `
            <div class="rounded-full w-4 h-4 bg-primary-blue-01 text-primary-white-01 paragraph-tag_upper font-bold text-center">
                P
            </div>`;
        } else {
            salida += `
            <div class="rounded-full w-4 h-4 bg-primary-gray-01 text-primary-white-01 paragraph-tag_upper font-bold text-center">
                P
            </div>`;
        }

        if (row.ADJUNTO_FACTURA > 0) {
            salida += ` 
            <div class="rounded-full w-4 h-4 bg-primary-blue-01 text-primary-white-01 paragraph-tag_upper font-bold text-center">
                F
            </div>`;
        } else {
            salida += ` 
            <div class="rounded-full w-4 h-4 bg-primary-gray-01 text-primary-white-01 paragraph-tag_upper font-bold text-center">
                F
            </div>`;
        }

        if (row.ADJUNTO_CONTRATO > 0) {
            salida += `
            <div class="rounded-full w-4 h-4 bg-primary-blue-01 text-primary-white-01 paragraph-tag_upper font-bold text-center">
                C
            </div>`;
        } else {
            salida += `
            <div class="rounded-full w-4 h-4 bg-primary-gray-01 text-primary-white-01 paragraph-tag_upper font-bold text-center">
                C
            </div>`;
        }
        salida += '</div>';
        return salida;
    }

    hasItem(carpeta: ListaCarpeta) {
        return this.selection.selected.some(({ ID_CARPETA }) => {
            return ID_CARPETA === carpeta.ID_CARPETA;
        });
    }

    handleClick(carpeta: ListaCarpeta): void {
        let payload: ListaCarpeta[] = [];

        const checked = this.selection.selected.some(({ ID_CARPETA }) => {
            return ID_CARPETA === carpeta.ID_CARPETA;
        });

        if (!checked) {
            payload = [...this.selection.selected, carpeta];
        } else {
            payload = this.selection.selected.filter(({ ID_CARPETA }) => ID_CARPETA !== carpeta.ID_CARPETA);
        }

        this.selection = new SelectionModel<ListaCarpeta>(true, [...payload]);
    }

    imprimirPagares(): void {
        if (this.selection.selected.length > 0) {
            let arrFolios = this.selection.selected.map((carpeta) => carpeta.ID_CARPETA + '/' + carpeta.FOLIO);
            this.loadingPrint = true;
            this._pdf.obtenerPdfMultiplesPagares(arrFolios).subscribe({
                next: (data: any) => {
                    console.log('print ok');
                    this._pdf.printFn(data.body, 'pdf');
                    this.loadingPrint = false;
                },
                error: (e: any) => {
                    console.log('print err');
                    this.loadingPrint = false;
                },
                complete: () => {},
            });
        }
    }
}
